import React, { useContext, useEffect, useMemo, useState } from "react";
import PaymentHistory from "./PaymentHistory";
import { AuthContext } from "../../context/AuthContext";
import { fetchPaymentHistory } from "../../services/resident_api";

const PaymentHistoryList = ({
  residentName: nameProp,
  residentPhone: phoneProp,
}) => {
  const { user } = useContext(AuthContext);
  const accessToken =
    typeof window !== "undefined" ? localStorage.getItem("access_token") : null;

  // derive resident identity (props win; fall back to AuthContext)
  const residentName = useMemo(
    () => nameProp ?? user?.name ?? user?.member_data?.name ?? "",
    [nameProp, user]
  );
  const residentPhone = useMemo(
    () =>
      phoneProp ??
      user?.phone_number?.trim() ??
      user?.member_data?.phone_number?.trim() ??
      "",
    [phoneProp, user]
  );

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const mapToCard = (item) => ({
    planDuration: item.plan_name || "N/A",
    paymentDate: new Date(item.created_at).toLocaleString(),
    amount: Number(item.amount),
    planPrice: Number(item.amount), // adjust if your API returns a different field
    paymentMode: item.payment_id ? "Card" : "Unpaid",
    paymentId: item.payment_id || item.order_id,
  });

  useEffect(() => {
    let alive = true;
    const go = async () => {
      if (!accessToken) {
        setItems([]);
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        const res = await fetchPaymentHistory(accessToken);
        // expect: { success, data: [...] }
        if (res?.success && Array.isArray(res.data)) {
          // keep only this resident’s entries (by phone OR name)
          const filtered = res.data.filter(
            (r) =>
              (residentPhone &&
                String(r.resident_phone) === String(residentPhone)) ||
              (residentName && r.resident_name === residentName)
          );
          const mapped = filtered.map(mapToCard);
          if (alive) setItems(mapped);
        } else {
          if (alive) setItems([]);
        }
      } catch (e) {
        console.error("❌ Payment history fetch failed:", e);
        if (alive) setItems([]);
      } finally {
        if (alive) setLoading(false);
      }
    };
    go();
    return () => {
      alive = false;
    };
  }, [accessToken, residentName, residentPhone]);

  if (loading) return null; // keep your page’s design; no extra spinners/text

  return items.length ? (
    items.map((entry, idx) => <PaymentHistory key={idx} data={entry} />)
  ) : (
    <p className="text-gray-600">No payment history available.</p>
  );
};

export default PaymentHistoryList;
